import { Component, input } from '@angular/core';
import { AbstractControl, FormGroup, ReactiveFormsModule } from '@angular/forms';
import { MdbFormsModule } from 'mdb-angular-ui-kit/forms';
import { MdbOptionModule } from 'mdb-angular-ui-kit/option';
import { MdbSelectModule } from 'mdb-angular-ui-kit/select';
import { TranslateModule } from '@ngx-translate/core';
import { MdbValidationModule } from 'mdb-angular-ui-kit/validation';
import { SelectorModel } from '../../../models/table-column.model';

@Component({
  selector: 'app-form-select',
  imports: [
    MdbFormsModule,
    MdbOptionModule,
    MdbSelectModule,
    ReactiveFormsModule,
    TranslateModule,
    MdbValidationModule
  ],
  template: `
    <mdb-form-control [formGroup]="formGroup()">
      <mdb-select
        [clearButton]="clear()"
        [filterPlaceholder]="('SEARCH'| translate) + '...'"
        [filter]="filter()"
        [multiple]="multiple()"
        [notFoundMsg]="'NO_RESULTS_FOUND' | translate"
        [optionsSelectedLabel]="'OPTIONS_SELECTED' | translate"
        formControlName="{{ controlName() }}"
        placeholder="{{placeholder() ? (placeholder()!|translate) : null}}">
        @for (option of options(); track option) {
          <mdb-option
            [value]="optionValueSelector() ? getOptionValue(option) : option">
            {{ this.translateOptionLabels() ? (getOptionLabel(option) | translate) : getOptionLabel(option) }}
          </mdb-option>
        }
      </mdb-select>
      @if (!hideLabel()) {
        <label class="form-label" mdbLabel>
          {{ label() | translate }}
          @if (isRequired()) {
            <span>*</span>
          }
        </label>
      }

      @if (isRequired() &&
      control?.hasError('required') &&
      (control?.dirty || control?.touched)) {
        <mdb-error>
          {{ label() | translate }} {{ 'VALIDATION.IS_REQUIRED' | translate }}.
        </mdb-error>
      }

      @if (this.loading()) {
        <div class="autocomplete-loader spinner-border" role="status"></div>
      }
    </mdb-form-control>
  `,
  standalone: true,
  styles: ''
})
export class FormSelectComponent {
  id = input.required<string>();
  label = input.required<string>();
  hideLabel = input(false);
  controlName = input.required<string>();
  formGroup = input.required<FormGroup>();
  isRequired = input(false);
  options = input.required<any[] | undefined>();
  optionLabelSelector = input.required<SelectorModel[]>();
  filter = input(false);
  multiple = input(false);
  clear = input(false);
  optionValueSelector = input<string | undefined>();
  placeholder = input<string>();
  translateOptionLabels = input<boolean>(false);
  loading = input<boolean>(false);

  getOptionLabel(data: any) {
    let result = '';
    this.optionLabelSelector().forEach((s: SelectorModel) => {
      let splits = s.selector.split('.');
      let selectorResult = data;
      splits.forEach((sp) => {
        selectorResult = selectorResult[sp];
      });

      if(s.castFunction)
        selectorResult = s.castFunction(selectorResult);
      result += selectorResult;
      if (s.suffix) result += s.suffix;
    });
    return result;
  }

  get control(): AbstractControl | null {
    return this.formGroup().get(this.controlName());
  }

  getOptionValue(data: any): any {
    let splits = this.optionValueSelector()!.split('.');
    let valueResult = data;
    splits.forEach((sp) => {
      valueResult = valueResult ? valueResult[sp] : null;
    });
    return valueResult;
  }
}
